export default {"src":"/_next/static/media/washer.304689f4.svg","height":24,"width":25,"blurWidth":0,"blurHeight":0};